// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';

const contactInfoReducer = (state) => state.contactinfo || initState;

const contactInfoData = createSelector(contactInfoReducer, (cnter) => cnter.contactInfoData.contacts);
const isContactLoading = createSelector(contactInfoReducer, (cnter) => cnter.isContactLoading);


export default {
	contactInfoData,
    isContactLoading,
    contactInfoReducer
};
